module.exports = __webpack_public_path__ + "static/media/github.285b1b7a.svg";